import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "priorityMedium",
  "use": "priorityMedium-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"priorityMedium\">\n<circle cx=\"8\" cy=\"8\" r=\"8\" fill=\"#FCB855\" />\n<line x1=\"5\" y1=\"8\" x2=\"11\" y2=\"8\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol